import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "katex/dist/katex.min.css";
import "./index.css";

createRoot(document.getElementById("racine")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
